import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Match } from '../../_shared/models/match.model';
import Hls from 'hls.js';

@Component({
  selector: 'app-video-tab',
  templateUrl: './video-tab.component.html',
  styleUrls: ['./video-tab.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class VideoTabComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() match: Match;
  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef;

  safeUrl!: string;
  videoLoading = false;
  private hlsInstance: Hls | null = null;


  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    // Initialize or pre-load any data if needed
  }

  ngAfterViewInit() {
    // Initialize video once the view has been initialized
    this.initializeVideo();
  }

  private initializeVideo(): void {
    if (!this.match || !this.videoPlayer || !Hls.isSupported()) return; // Exit early if no match or videoPlayer element

    const videoElement = this.videoPlayer.nativeElement as HTMLVideoElement;
    this.videoLoading = true;

    const stream = this.getStreamFromMatch(this.match);
    if (!stream) {
      this.videoLoading = false;
      return; // Exit if no stream available
    }
    this.safeUrl = stream.hls;
    this.cdr.detectChanges(); // Update view for the safeUrl
    this.setupHls(videoElement, stream);
    
  }

  private getStreamFromMatch(match: Match): any | null {
    const activeCamera = match.cameras?.find(camera =>
      camera?.extensions?.some(extension => extension?.value?.stream)
    );
    
    if (activeCamera) {
      return activeCamera.extensions?.find(extension => extension?.value?.stream)?.value?.stream || null;
    }
    
    if (match.videoLinks) {
      return match.videoLinks.extensions?.find(extension => extension?.value?.stream)?.value?.stream || null;
    }
    
    return null;
  }

  private setupHls(videoElement: HTMLVideoElement, stream: any): void {
    this.hlsInstance = new Hls();

    this.hlsInstance.loadSource(this.safeUrl);

    this.hlsInstance.attachMedia(videoElement);
    this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => {
      this.configureVideoStartTime(videoElement, stream);
      this.videoLoading = false;
      videoElement.play(); // Start the video once it's ready
    });

  }

  private configureVideoStartTime(videoElement: HTMLVideoElement, stream: any): void {
    const matchStartTime = Math.floor(new Date(this.match?.startDate as Date).getTime() / 1000);
    const videoStartTime = stream.start_time;

    // Calculate relative video start time and set it
    videoElement.currentTime = matchStartTime > videoStartTime
      ? matchStartTime - videoStartTime
      : videoStartTime;
  }

  ngOnDestroy(): void {

    // Pause and clean up video element

    if (this.videoPlayer?.nativeElement) {
      const videoElement = this.videoPlayer.nativeElement as HTMLVideoElement;
      videoElement.pause();
      videoElement.src = '';
      videoElement.load();
    }


    // Destroy HLS instance to stop downloading chunks
    if (this.hlsInstance) {
      this.hlsInstance.destroy();
      this.hlsInstance = null;
    }
  }
}
